import { api } from '../utils/apiClient';

export const fetchUsers = async (params = {}) => {
  const response = await api.get('/api/users', { params });
  return response.data;
};

export const getUserById = async (userId) => {
  const response = await api.get(`/api/users/${userId}`);
  return response.data;
};

export const createUser = async (userData) => {
  const response = await api.post('/api/users', userData);
  return response.data;
};

export const updateUser = async (userId, userData) => {
  const response = await api.patch(`/api/users/${userId}`, userData);
  return response.data;
};

export const updateUserRole = async (userId, role) => {
  const response = await api.patch(`/api/users/${userId}/role`, { role });
  return response.data;
};

export const deleteUser = async (userId) => {
  const response = await api.delete(`/api/users/${userId}`);
  return response.data;
};

export const bulkActionUsers = async (action, userIds, additionalData = {}) => {
  const response = await api.post('/api/users/bulk-action', {
    action,
    userIds,
    ...additionalData,
  });
  return response.data;
};

export const updateUserActivity = async () => {
  const response = await api.post('/api/users/activity');
  return response.data;
};

export const changePassword = async (userId, newPassword) => {
  const response = await api.patch(`/api/users/${userId}/password`, { newPassword });
  return response.data;
};

// Application Password functions
export const createApplicationPassword = async (userId, name) => {
  const response = await api.post(`/api/users/${userId}/application-passwords`, { name });
  return response.data;
};

export const getApplicationPasswords = async (userId) => {
  const response = await api.get(`/api/users/${userId}/application-passwords`);
  return response.data;
};

export const revokeApplicationPassword = async (userId, passwordId) => {
  const response = await api.delete(`/api/users/${userId}/application-passwords/${passwordId}`);
  return response.data;
};

export const revokeAllApplicationPasswords = async (userId) => {
  const response = await api.delete(`/api/users/${userId}/application-passwords`);
  return response.data;
};


